<template>
  <li :class="[
    is_locked && !is_completed && !is_unlocked && (!is_demo || has_been_assigned) && can_open_contents_in_order ? 'locked' : '',
    (is_unlocked || is_demo) && !has_been_assigned ? 'unlocked' : '',
    is_completed ? 'completed' : '',
    is_current ? 'current' : '',
    is_unlocked ? 'active' : '',
  ]">
    <div class="icon-cat d-flex align-items-center"
      :style="is_locked && !is_demo && can_open_contents_in_order ? 'cursor:no-drop' : 'cursor:pointer'"
      @click.prevent="linkClick">
      <i :class="icon" class="mr-1"></i>{{ name }}
    </div>
    <a class="assignment-content-link" href="javascript:void(0)"
      :style="is_locked && !is_demo && can_open_contents_in_order ? 'cursor:no-drop' : ''"
      @click.prevent="linkClick">
      <span class="assignment-content-title">
        {{ title }}
        <span v-if="contentItem?.pivot.timed_content_type === 'timed_content'" class="assignment-content-dates">
          ({{ $t("general.start_date") }}: {{ contentItem.pivot.starts_at }}
          {{ $t("general.end_date") }}: {{ contentItem.pivot.ends_at }})
        </span>
      </span>
      <span v-if="contentInstructors.length" class="assignment-content-instructors">
        <span v-for="(instructor, index) in contentInstructors"
          :key="instructor.id || `content-instructor-${index}`"
          class="assignment-content-instructor">
          <i class="uil-user"></i>
          {{ instructor.name }}
        </span>
      </span>
    </a>
    <span>
      <!-- Yetkinlikler -->
      <div v-if="contentItem?.competencies && contentItem.competencies.length > 0" class="competencies-dropdown">
        <span class="competencies-badge">
          <i class="uil-award"></i> {{ $t('general.competencies_to_be_acquired') }} ({{ contentItem.competencies.length
          }})
          <i class="uil-angle-down dropdown-icon"></i>
        </span>
        <div class="competencies-list">
          <div v-for="(competency, index) in contentItem.competencies" :key="'competency_' + competency.id"
            class="competency-item">
            <span class="competency-name">{{ competency.name }}</span>
            <i v-if="competency.requires_approval" class="uil-check-circle approval-icon"></i>
          </div>
        </div>
      </div>

      <span class="uil-lock-alt"
        v-if="is_locked && !is_completed && !is_unlocked && !is_demo && can_open_contents_in_order"></span>
      <template v-if="is_completed"><i v-if="certificate_id" @click="$emit('show_certificate')"
          :uk-tooltip="'title:Tamamlama Sertifikası'" class="uil-award mr-1 cursor-pointer"></i><i
          class="uil-check-circle mr-1"></i></template>

      <template v-if="has_been_assigned">
        <span>
          <template v-if="contentItem.file_category?.id === 12 && !is_completed">
            Geçme puanı :
          </template>

          {{ point | nullToZero }} {{ $t("point.point") }}
        </span>
      </template>
      <span v-if="!has_been_assigned && is_demo">Demo</span>
    </span>
  </li>
</template>

<script>
import Vue from 'vue';
Vue.filter('nullToZero', function (value) {
  if (!value) return 0

  return value;
});
export default {
  name: "ContentItem",
  props: {
    title: {
      required: true,
    },
    point: {
      required: true,
    },
    name: {
      required: true,
    },
    icon: {
      required: true,
    },
    is_completed: {
      required: false,
      default: false,
    },
    has_been_assigned: {
      required: false,
      default: true,
    },
    is_current: {
      required: false,
      default: false,
    },
    is_locked: {
      required: false,
      default: true,
    },
    is_unlocked: {
      required: false,
      default: false,
    },
    is_demo: {
      required: false,
      default: false,
    },
    certificate_id: {
      required: false,
      default: null,
    },
    can_open_contents_in_order: {
      required: false,
      default: null,
    },
    contentItem: {
      required: false,
      default: null,
    }
  },
  computed: {
    contentInstructors() {
      if (!Array.isArray(this.contentItem?.instructors)) return [];

      return this.contentItem.instructors
        .map((instructor) => {
          const user = instructor?.user || {};
          const name =
            [user.name, user.surname].filter(Boolean).join(" ").trim() ||
            instructor?.full_name ||
            instructor?.name ||
            "";

          return {
            id: instructor?.id,
            name,
          };
        })
        .filter((instructor) => instructor.name);
    },
  },
  methods: {
    linkClick() {
      if (this.is_locked && !this.is_completed && !this.is_unlocked && !this.is_demo && this.can_open_contents_in_order)
        return false;
      this.$emit("linkClick");
    },
  },
};
</script>
<style>
.cursor-pointer {
  cursor: pointer;
}

.course-curriculum-list .active {
  background: #d6d7e8;
}

.icon-cat {
  color: white !important;
}

.icon-cat i {
  color: white !important;
}

.assignment-content-link {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 5px;
}

.assignment-content-title {
  color: inherit;
  line-height: 1.4;
}

.assignment-content-dates {
  font-weight: 600;
}

.assignment-content-instructors {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
}

.assignment-content-instructor {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 7px;
  border: 1px solid #dbeafe;
  border-radius: 999px;
  background: #eff6ff;
  color: #2563eb;
  font-size: 11px;
  font-weight: 500;
  line-height: 1.4;
}

.assignment-content-instructor i {
  color: inherit !important;
  font-size: 12px;
}

/* Competencies Dropdown Styles */
.competencies-dropdown {
  display: inline-block;
  margin-left: 8px;
  position: relative;
}

/* Parent li element overflow fix */
.course-curriculum-list>li {
  overflow: visible !important;
}

.competencies-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  padding: 3px 8px;
  border-radius: 4px;
  background: #f1f5f9 !important;
  color: #475569 !important;
  border: 1px solid #e2e8f0;
  box-shadow: none;
  transition: all 0.15s ease;
  font-weight: 500;
  cursor: pointer;
}

.competencies-badge:hover {
  background: #e2e8f0 !important;
}

.competencies-badge i {
  font-size: 12px;
  color: #64748b !important;
}

.dropdown-icon {
  font-size: 10px !important;
  color: #94a3b8 !important;
  transition: transform 0.2s ease;
  margin-left: 4px;
}

.dropdown-icon.rotated {
  transform: rotate(180deg);
}

.competencies-list {
  position: absolute;
  top: 100%;
  right: 0;
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  min-width: 220px;
  max-width: 320px;
  z-index: 1000;
  margin-top: 6px;
  padding: 8px 0;
  opacity: 0;
  visibility: hidden;
  transform: translateY(-6px);
  transition: all 0.15s ease;
}

.competencies-dropdown:hover .competencies-list {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}

.competency-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 14px;
  transition: background 0.15s;
  border-left: 3px solid transparent;
}

.competency-item:hover {
  background: #f8fafc;
}

.competency-name {
  font-size: 13px;
  color: #475569;
  flex: 1;
  font-weight: 500;
  margin-left: 8px;
}

.approval-icon {
  color: #16a34a;
  font-size: 14px;
  background: rgba(22, 163, 74, 0.08);
  border-radius: 50%;
  padding: 2px;
}

/* Responsive — tablet */
@media (max-width: 768px) {
  .competencies-badge {
    font-size: 10px;
    padding: 2px 6px;
    gap: 3px;
  }

  .competencies-badge i {
    font-size: 11px;
  }

  .competencies-list {
    min-width: 180px;
    max-width: 260px;
    right: 0;
  }

  .competency-item {
    padding: 6px 10px;
  }

  .competency-name {
    font-size: 12px;
    margin-left: 6px;
  }
}

/* Responsive — mobile */
@media (max-width: 480px) {
  .assignment-content-instructors {
    gap: 4px;
  }

  .assignment-content-instructor {
    padding: 2px 6px;
    font-size: 10px;
  }

  .competencies-dropdown {
    margin-left: 0;
  }

  .competencies-badge {
    font-size: 10px;
    padding: 2px 5px;
  }

  .competencies-badge .dropdown-icon {
    display: none;
  }

  .competencies-list {
    position: fixed;
    top: auto;
    bottom: 0;
    left: 0;
    right: 0;
    min-width: 100%;
    max-width: 100%;
    border-radius: 12px 12px 0 0;
    margin-top: 0;
    box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.15);
    max-height: 50vh;
    overflow-y: auto;
    padding: 12px 0;
  }

  .competency-item {
    padding: 10px 16px;
  }

  .competency-name {
    font-size: 13px;
  }
}
</style>

